import { StateCreator } from 'zustand';
import { SectionSliceState } from './types';

export const createSectionSlice: StateCreator<
  SectionSliceState,
  [],
  [],
  SectionSliceState
> = (set) => ({
  sectionId: undefined,
  sectionTitle: '',
  
  setSectionId: (sectionId) => 
    set({ sectionId }),
  
  setSectionTitle: (sectionTitle) => 
    set({ sectionTitle }),
  
  setSection: (sectionId, sectionTitle) => 
    set({ sectionId, sectionTitle }),
  
  resetSection: () => 
    set({ sectionId: undefined, sectionTitle: '' }),
});